module.exports = __webpack_public_path__ + "img/fa004b3.png";